import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


import {
  StyledCheckIcon,
  StyledCloseIcon,
} from './PricingFeature.style';
import { formatNumber } from 'utils/formatPricing';

const PricingFeatureTeam = ({ categories, locale }) => {
  const renderValueIcon = (value) => {
    if (value === true) return <StyledCheckIcon />;
    if (value === false) return <StyledCloseIcon />;
    if (typeof value === 'number') {
        return <Typography>{formatNumber(value)}</Typography>;
      }
    return <Typography>{value}</Typography>;
  };

  return (
    <Table>
      <TableBody>
        {categories.map((category, index) => (
          <React.Fragment key={index}>
            <TableRow sx={{background:'rgb(236, 232, 232)'}}>
              <TableCell colSpan={5}>
                <Typography fontWeight={600}>
                  {locale === 'en-us'
                    ? category.name
                    : category.nameFR || category.name}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {locale === 'en-us'
                    ? category.description
                    : category.descriptionFR || category.description}
                </Typography>
              </TableCell>
            </TableRow>

            {category.features.length > 15 ? (
              <TableRow>
                <TableCell
                  colSpan={5}
                  sx={{ padding: 0, borderBottom: 'none' }}
                >
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-content-${index}`}
                      id={`panel-header-${index}`}
                    >
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: 0 }}>
                      <Table size="small" aria-label="features-table">
                        <TableBody>
                          {category.features.map((feature, featureIndex) => (
                            <TableRow key={featureIndex}>
                              <TableCell sx={{ width: '180px' }}>
                                <Box>
                                  {locale === 'en-us'
                                    ? feature.name
                                    : feature.nameFR || feature.name}
                                </Box>
                              </TableCell>
                              <TableCell align="center">
                                {renderValueIcon(feature.values?.[0]?.free)}
                              </TableCell>
                              <TableCell align="center">
                                {renderValueIcon(feature.values?.[1]?.starter)}
                              </TableCell>
                              <TableCell align="center">
                                {renderValueIcon(feature.values?.[2]?.pro)}
                              </TableCell>
                              <TableCell align="center">
                                {renderValueIcon(feature.values?.[3]?.ultra)}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>
                </TableCell>
              </TableRow>
            ) : (
              category.features.map((feature, featureIndex) => (
                <TableRow key={featureIndex}>
                  <TableCell sx={{ width: '180px' }}>
                    <Box>
                      {locale === 'en-us'
                        ? feature.name
                        : feature.nameFR || feature.name}
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    {renderValueIcon(feature.values?.[0]?.free)}
                  </TableCell>
                  <TableCell align="center">
                    {renderValueIcon(feature.values?.[1]?.starter)}
                  </TableCell>
                  <TableCell align="center">
                    {renderValueIcon(feature.values?.[2]?.pro)}
                  </TableCell>
                  <TableCell align="center">
                    {renderValueIcon(feature.values?.[3]?.ultra)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </React.Fragment>
        ))}
      </TableBody>
    </Table>
  );
};

export default PricingFeatureTeam;
